import ApiService from '../../../../../services/ApiService'

export default {
  props: {
    title: String,
    templateId: Number,
    parameter: Object,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getCalibrationPattern()

    if (this.templateId) {
      this.calibrationPatternTemplateId = this.templateId
    }

    if (this.parameter) {
      this.currentParameter = this.parameter
      this.calibrationPatternTemplateId =
        this.parameter.calibrationPatternTemplateId
      this.calibrationPatternId = this.parameter.calibrationPatternId
      this.listCalibrationMetrics()
      this.calibrationMetric = this.parameter.calibrationPatternMetrics
      this.calibrationMetricId = this.parameter.calibrationPatternMetrics.id
      this.listCalibrationMetricsRanges()
      this.calibrationMetricsRangeSelected =
        this.parameter.calibrationPatternTemplateParametersMetricsRanges.map(
          (range) => range.calibrationPatternMetricsRange
        )

      this.isEditing = true
    }

    this.calibrationPatternTemplateId = this.templateId
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    loading: false,
    calibrationPatternLoading: false,
    calibrationMetricsLoading: false,
    calibrationMetricsRangeLoading: false,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    institutionId: null,
    calibrationPatternTemplateId: null,
    calibrationPatternId: null,
    calibrationPatterns: [],
    calibrationMetricId: null,
    calibrationMetric: null,
    calibrationMetrics: [],
    calibrationMetricsRangeSelected: [],
    calibrationMetricsRanges: [],
    currentParameter: {
      id: 0,
      name: '',
      tolerance: '',
      fixedValue: false,
    },
    nameRules: [
      (v) => !!v || 'Parâmetro requerido',
      (v) =>
        (v && v.length <= 128) || 'Parâmetro deve ter no máximo 128 caracteres',
    ],
    calibrationPatternRulles: [(v) => !!v || 'Padrão requerida'],
    calibrationMetricRulles: [(v) => !!v || 'Métrica requerida'],
    toleranceRules: [(v) => !!v || 'Tolerância requerida'],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    removeRange(item) {
      this.calibrationMetricsRangeSelected.splice(
        this.calibrationMetricsRangeSelected.indexOf(item),
        1
      )
      this.calibrationMetricsRangeSelected = [
        ...this.calibrationMetricsRangeSelected,
      ]
    },

    selectAllMetricsRanges() {
      this.calibrationMetricsRangeSelected = []

      this.calibrationMetricsRangeSelected = this.calibrationMetricsRanges
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          if (
            this.calibrationPatterns
              .map((x) => x.id)
              .includes(this.calibrationPatternId) &&
            this.calibrationMetrics
              .map((x) => x.name)
              .includes(this.calibrationMetric.name)
          ) {
            this.submit()
          } else {
            this.calibrationPatternId = null
            this.calibrationMetric = null
          }
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true

        const calibrationPatternTemplateParameter = {
          Parameter: {
            Id: this.currentParameter.id,
            Name: this.currentParameter.name,
            Tolerance: this.currentParameter.tolerance,
            FixedValue: this.currentParameter.fixedValue,
            CalibrationPatternTemplateId: this.calibrationPatternTemplateId,
            CalibrationPatternId: this.calibrationPatternId,
            CalibrationPatternMetricsId: this.calibrationMetricId,
            InstitutionId: this.institutionId,
          },
          Ranges: this.calibrationMetricsRangeSelected,
        }

        let url = 'calibrationPatternTemplateParameter/add'

        if (this.isEditing) {
          url = 'calibrationPatternTemplateParameter/edit'
        }

        await this.apiService
          .post(url, calibrationPatternTemplateParameter)
          .then(() => {
            this.step++
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })

        this.loading = false
        this.changedData = false
      }
    },

    async getCalibrationPattern() {
      this.calibrationPatternLoading = true

      await this.apiService
        .get(`calibrationPattern/listCalibrations/${this.institutionId}`)
        .then((response) => {
          this.calibrationPatterns = response.content
          this.calibrationPatternLoading = false
        })
    },

    async listCalibrationMetrics() {
      await this.apiService
        .get(
          `calibrationPatternMetrics/list/${this.currentParameter.calibrationPatternId}`
        )
        .then((response) => {
          this.calibrationMetrics = response.content
        })
    },

    async listCalibrationMetricsRanges() {
      await this.apiService
        .get(`calibrationPatternMetricsRange/list/${this.calibrationMetric.id}`)
        .then((response) => {
          this.calibrationMetricsRanges = response.content.filter(
            (x) => x.createdByOrder == false
          )

          console.log(this.calibrationMetricsRanges)
        })
    },

    getCalibrationMetrics(value) {
      this.calibrationMetrics = this.calibrationPatterns.find(
        (x) => x.id === value
      ).calibrationPatternMetrics

      this.calibrationMetric = null
      this.calibrationMetricsRangeSelected = []
    },

    getMetricRanges(value) {
      this.calibrationMetricId = value.id
      this.calibrationMetricsRanges =
        value.calibrationPatternMetricsRanges.filter(
          (x) => x.createdByOrder == false
        )
    },
  },

  watch: {
    currentParameter: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
    calibrationPatternId: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
